import { z } from 'zod';

const schema = z.object({
  VITE_DOCS_URL: z.string(),
  VITE_API_ENDPOINT: z.string(),
  VITE_SUBSCRIPTION_ENDPOINT: z.string(),
  VITE_PUBLIC_BUCKET: z.string(),
  VITE_LOGIN_URL: z.string(),
  VITE_TINKER_CLI_VERSION: z.string(),
  VITE_SENTRY_DSN: z.string(),
  VITE_SENTRY_TUNNEL: z.string()
});

export const config = schema.parse(import.meta.env);
